module.exports = __webpack_public_path__ + "img/ac10_thumb.191da045.jpg";